export function Play({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 8.99956V6.32955C3 3.01455 5.3475 1.65706 8.22 3.31456L10.5375 4.64956L12.855 5.98456C15.7275 7.64206 15.7275 10.3571 12.855 12.0146L10.5375 13.3496L8.22 14.6846C5.3475 16.3421 3 14.9846 3 11.6696V8.99956Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
